export default "__VITE_ASSET__SwckTT1m__"